import React from "react";
import PreLoader from "./preloader";

export default function centeredLoadingIndicator() {
	return (
		<div
			style={{
				position: "relative",
				width: "100%",
				height: "100%",
				margin: 0,
				padding: 0
			}}>
			<div
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)"
				}}>
				<PreLoader />
			</div>
		</div>
	);
}
